import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) =>
    !props.dark ? props.theme.colors.light2 : props.theme.colors.dark1};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PostLayout = styled.div`
  display: flex;
  width: 100%;
  max-width: 1500px;
`;
